import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, resolveDynamicComponent as _resolveDynamicComponent, withModifiers as _withModifiers, mergeProps as _mergeProps, withCtx as _withCtx, createSlots as _createSlots, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_SourceSup = _resolveComponent("SourceSup")
  const _component_HtmlMapper = _resolveComponent("HtmlMapper", true)
  const _component_CollapsedMdTable = _resolveComponent("CollapsedMdTable")
  const _component_Button = _resolveComponent("Button")
  const _component_ExternalLink = _resolveComponent("ExternalLink")

  return (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.processed_nodes, (node, idx) => {
    return (_openBlock(), _createElementBlock(_Fragment, { key: idx }, [
      (node.type === 'source')
        ? (_openBlock(), _createBlock(_component_SourceSup, {
            key: 0,
            num: node.content
          }, null, 8 /* PROPS */, ["num"]))
        : (node.type === 'table')
          ? (_openBlock(), _createBlock(_component_CollapsedMdTable, { key: 1 }, _createSlots({
              default: _withCtx(() => [
                _createVNode(_component_HtmlMapper, {
                  restricted: $props.restricted,
                  nodes: node.content
                }, null, 8 /* PROPS */, ["restricted", "nodes"])
              ]),
              _: 2 /* DYNAMIC */
            }, [
              (node.title)
                ? {
                    name: "title",
                    fn: _withCtx(() => [
                      (_openBlock(), _createBlock(_resolveDynamicComponent(node.title.name), _mergeProps({ ref_for: true }, node.attributes, {
                        onClick: _cache[0] || (_cache[0] = _withModifiers(() => {}, ["prevent"]))
                      }), {
                        default: _withCtx(() => [
                          _createVNode(_component_HtmlMapper, {
                            restricted: $props.restricted,
                            nodes: node.title.content
                          }, null, 8 /* PROPS */, ["restricted", "nodes"])
                        ]),
                        _: 2 /* DYNAMIC */
                      }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1024 /* DYNAMIC_SLOTS */))
          : (node.type === 'button')
            ? (_openBlock(), _createBlock(_component_Button, {
                key: 2,
                disabled: $props.restricted,
                tiny: "",
                onClick: $event => (_ctx.$dispatch('inline-button', node.click))
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(node.text), 1 /* TEXT */)
                ]),
                _: 2 /* DYNAMIC */
              }, 1032 /* PROPS, DYNAMIC_SLOTS */, ["disabled", "onClick"]))
            : (node.type === 'external-link')
              ? (_openBlock(), _createBlock(_component_ExternalLink, {
                  key: 3,
                  href: node.href
                }, null, 8 /* PROPS */, ["href"]))
              : (node.type === 'parent')
                ? (_openBlock(), _createBlock(_resolveDynamicComponent(node.name), _mergeProps({
                    key: 4,
                    ref_for: true
                  }, node.attributes, {
                    onClick: _cache[1] || (_cache[1] = _withModifiers(() => {}, ["prevent"]))
                  }), {
                    default: _withCtx(() => [
                      _createVNode(_component_HtmlMapper, {
                        restricted: $props.restricted,
                        nodes: node.content
                      }, null, 8 /* PROPS */, ["restricted", "nodes"])
                    ]),
                    _: 2 /* DYNAMIC */
                  }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                : (!!node.name)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(node.name), _mergeProps({
                      key: 5,
                      ref_for: true
                    }, node.attributes, {
                      onClick: _cache[2] || (_cache[2] = _withModifiers(() => {}, ["prevent"]))
                    }), {
                      default: _withCtx(() => [
                        _createTextVNode(_toDisplayString(node.content), 1 /* TEXT */)
                      ]),
                      _: 2 /* DYNAMIC */
                    }, 1040 /* FULL_PROPS, DYNAMIC_SLOTS */))
                  : (_openBlock(), _createElementBlock(_Fragment, { key: 6 }, [
                      _createTextVNode(_toDisplayString(node.content), 1 /* TEXT */)
                    ], 64 /* STABLE_FRAGMENT */))
    ], 64 /* STABLE_FRAGMENT */))
  }), 128 /* KEYED_FRAGMENT */))
}